<template>
  <el-drawer
  :title="title"
  :visible.sync="visible"
  :direction="direction"
  :before-close="close"
  :size="width"
  @open="open">
  <div class="drawer__content scrollable only-y" :style="divHeight"   v-loading="fullScreenLoading">
    <el-form ref="form" :model="model" :rules="rules" label-position="top">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
           <el-form-item :label="$t('common.product')" prop="product">
              <SeachProduct @selected="handleSelectProduct" :type="1" :product="this.model.product" :inventoryId="inventoryId" @clear="model.product=null"></SeachProduct>
            </el-form-item>
        </el-col>
        <el-col v-if="model.product!=null">
          <ProductSummary :product="model.product" class="m-20"></ProductSummary>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
           <el-form-item :label="$t('products.availabilityDate')" prop="availabilityDate">
             <el-date-picker
                v-model="model.availabilityDate"
                type="date"
                :picker-options="datePickerOptions">
              </el-date-picker>
            </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
           <el-form-item :label="$t('purchase_orders.lines.Reference')" prop="reference">
             <el-input v-model="model.reference"></el-input>
            </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <el-row>
            <el-col :xs="12" :sm="12" :md="12" :lg="10" :xl="8">
             <el-form-item :label="$t('common.quantity')" prop="qty">
               <el-input-number v-model="model.qty" :controls="false" ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="14" :xl="16" class="text-left" v-if="editionMode">
              <div class="border bg-accent-lighter p-10 mt-20" >
                <span class="fs-12">{{ $t('products.quantityRemaining') }} {{onHandQty}}</span>
                <span class="fs-12"><br>{{$t('products.minimumQuantity')}} {{minimumQty}}</span>
              </div>
            </el-col>
          </el-row>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <el-form-item v-if="inventory!=null && !inventory.ind_agency" :label="$t('purchase_orders.lines.purchase_price')">
            <el-input-number  v-model="model.purchaseUnitPrice" :controls="false"></el-input-number>
           </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <el-row>
            <el-col :xs="12" :sm="12" :md="12" :lg="10" :xl="10">
               <el-form-item v-if="inventory!=null && inventory.ind_agency" :label="$t('purchase_orders.lines.Price')" prop="price">
                 <el-input-number  v-model="model.price" :controls="false"></el-input-number>
                </el-form-item>
                <el-form-item  v-else :label="$t('purchase_orders.lines.StandardPrice')" prop="price">
                  <el-input-number  v-model="model.price" :controls="false"></el-input-number>
                 </el-form-item>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="14" :xl="14" class="text-left" v-if="agencyFees!=null && inventory.code==='IP'">
              <div class="border bg-accent-lighter p-10 mt-20" >
                <span class="fs-12">{{$t('products.agencyFeeValue')}} {{$n(agencyFees,'currency','CAD')}} <span v-if="percentageOfFees!=null">({{percentageOfFees}}%)</span></span>
              </div>
            </el-col>
          </el-row>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="inventory!=null && inventory.ind_agency">
           <el-form-item :label="$t('purchase_orders.lines.PriceTaxIn')" prop="priceTaxIn">
              <el-input-number  v-model="model.priceTaxIn"  :controls="false"></el-input-number>
            </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="model.extraInfo != null">
          <el-form-item :label="additionnalInformationLabel">
            <el-input v-model="model.extraInfo.vintage" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item :label="$t('products.technicalSheet')">
          <TechnicalSheetSelect
            :productItem="technicalSheet"
            :product="product"
            @change="handleTechnicalSheetChange"/>
        </el-form-item>
      </el-row>
    </el-form>
    <div class="dialog-footer card-shadow--large">
      <el-button @click="close">{{$t('common.Cancel')}}</el-button>
      <el-button @click="save">{{$t('common.save')}}</el-button>
    </div>
</div>
</el-drawer>
</template>
<script>

import itemsAPI from '@/services/API/items'
import inventoryAPI from '@/services/API/inventory'
import SeachProduct from '@/components/product/select-product'
import ProductSummary from '@/components/product/product-summary'
import TechnicalSheetSelect from '@/components/technical-sheet-select'
import { mapActions, mapState, mapGetters } from 'vuex';
import moment from 'moment'

export default {
  name: 'item-drawer',
	props: {
		visible : Boolean,
    direction : {
      type : String,
      default : "rtl" //rtl / ltr / ttb / tbb
    },
    itemId : Number,
    inventory : Object,
    edit : null,

	},
  data() {
    var validateReference = (rule, value, callback) => {
      if (this.isIP) {
        const regex = /\d-{1}\d/gm;
        const found = value.match(regex);
        if (found == null) {
          callback(new Error("Veuillez assurer de saisir le code de lot d'arrivage composé de chiffres séparés par un tiret."));
        }
        callback();
       
      } else {
        callback();
      }
    };
    return {
      model : {
        id : null,
        puid: null,
        product : null,
        availabilityDate : null,
        reference : null,
        price : null,
        priceTaxIn : null,
        qty : null,
        extraInfo: null,
        purchaseUnitPrice: null,
        productItem: null,
      },
      fullScreenLoading : false,
      window: {
        width: 0,
        height: 0
      },
      datePickerOptions: {
        disabledDate :this.chooseDateMinusOrEqualToNow
      },
      rules : {
        product : [
          { required: true, message: 'Veuillez sélectionner un produit', trigger: 'blur' }
        ],
        availabilityDate : [
          { required: true, message: 'Veuillez saisir une date de mise en disponibilité', trigger: 'blur' }
        ],
        reference : [
          { required: true, message: 'Veuillez saisir une valeur', trigger: 'blur' },
          { validator: validateReference, trigger: 'blur' },
        ],
        qty : [
          { required: true, message: 'Veuillez saisir une quantité', trigger: 'blur' }
        ],
        price : [
          { required: true, message: 'Veuillez saisir un prix', trigger: 'blur' }
        ]
      }
    };
  },components: {
    SeachProduct,
    ProductSummary,
    TechnicalSheetSelect
  },
	methods: {
    handleTechnicalSheetChange(technicalSheet) {
      this.model.productItem = technicalSheet;
    },
    handleSelectProduct(productSelected){
      this.model.product = productSelected;
      if (!this.editionMode) {
        return inventoryAPI.generatePuid(_.get(this.inventory, 'id'), productSelected.id)
          .then((response) => {
            this.model.puid = response.puid;
          })
      }

    },
    initialize(){
      if(this.editionMode){
        return Promise.resolve(this.edit);
      }
      return Promise.resolve(null);
    },
    resetFields(){
      this.model.product = null;
      this.model.availabilityDate = null;
      this.model.reference = null;
      this.model.price = null;
      this.model.priceTaxIn = null;
      this.model.purchaseUnitPrice = null;
      this.model.qty = null;
      this.model.extraInfo = null;
      this.model.puid = null;
      this.$refs['form'].resetFields();
    },
    initProperties(item){
      if(item!=null){
        this.model.id = item.id;
        this.model.product = item.product;
        this.model.availabilityDate = item.availabilityDate;
        this.model.reference = item.reference;
        this.model.price = item.price;
        this.model.priceTaxIn = item.priceTaxIn;
        this.model.productItem = item.productItem;
        this.model.purchaseUnitPrice = item.purchaseUnitPrice;
        this.model.qty = item.qty;
        this.model.extraInfo = _.cloneDeep(_.get(item, 'extraInfo'));
        this.model.puid = item.puid;
        if (this.model.extraInfo == null) {
          this.model.extraInfo = {
            vintage: null,
          }
        }
      } else {
        this.model.extraInfo = {
          vintage: null,
        }
      }

      return Promise.resolve(this.model);
    },
    open(){
      this.fullScreenLoading = true;
      this.initialize()
        .then(initObj=>this.initProperties(initObj))
        .then(()=>{this.fullScreenLoading=false;})
    },
    buildPostData(version){
      let postData = {};
      if (version === 'V1') {
        postData.product = {id:this.model.product.id}
      }
      postData.qty = this.model.qty;
      postData.price = this.model.price;
      postData.priceTaxIn = this.model.priceTaxIn;
      postData.reference = this.model.reference;
      postData.availabilityDate = this.model.availabilityDate;
      postData.purchaseUnitPrice = this.model.purchaseUnitPrice;
      postData.productItem = this.model.productItem;
      if (_.get(postData, 'productItem') == "") {
        postData.productItem = null;
      }
      postData.active = true;
      if (version === 'V1') {
        postData.inventory = {id:this.inventory.id};
      }
      postData.extraInfo = this.model.extraInfo;
      if (this.model.puid == null) {

      } else {
        postData.puid = this.model.puid;
      }

      return postData;
    },
    saveItem(){
      this.fullScreenLoading = true;
      return itemsAPI.saveItemV2(this.inventory.id, this.model.product.id, this.buildPostData('V2'))
        .then(item=>{
          this.$message.success(this.$i18n.t('inventory.item_created'));
          this.fullScreenLoading = false;
          this.$emit('add',item);
          this.close();
        }).catch(err=>{
          console.log(err);
          this.$message.error(this.$i18n.t('inventory.item_creation_failed'));
        })
    },
    updateItem(){
      this.fullScreenLoading = true;
      return itemsAPI.updateItemV2(this.inventory.id, this.model.product.id, this.model.id, this.buildPostData('V2'))
        .then(item=>{
          this.$message.success(this.$i18n.t('Inventory.item_updated'));
          this.fullScreenLoading = false;
          this.$emit('update', item);
          this.close();
        }).catch(err=>{
          console.log(err);
          this.$message.success(this.$i18n.t('Inventory.item_update_failed'));
        })
    },
    validateForm(){
      return this.$refs['form'].validate()
        .then(valid=>{
          if(valid) return true;
          else return Promise.reject(false);
        })
    },
    save(){
      this.validateForm()
        .then(()=>{
          if(!this.editionMode){
            this.saveItem()
          }else{
            this.updateItem();
          }
        })
    },
    close(){
      this.$emit('close');
      this.resetFields();

    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    chooseDateMinusOrEqualToNow (date) {
        return  date > new Date();
    },
	},
	computed: {
    additionnalInformationLabel() {
      if (this.isIP) {
        return "Millésime"
      } else {
        return this.$i18n.t('products.additionnalInformation');
      }
    },
    isIP() {
      return _.get(this.inventory, 'code') === 'IP';
    },
    inventoryId () {
      return _.get(this.inventory, 'id');
    },
    technicalSheet () {
      return _.get(this.model, 'productItem');
    },
    product () {
      return _.get(this.model, 'product');
    },
    agencyFees(){
      let fees = null;
      if(this.model.price!=null && this.model.product!=null){
        fees = this.model.product.agencyRate == null ? (this.model.product.sellingUnitPrice - this.model.price) : (Math.round((this.model.price * this.model.product.agencyRate)*100)/100);
      }
      return fees;
    },
    percentageOfFees(){
      let percentage = null;
      if(this.model.product!=null && this.model.product.agencyRate!=null){
        percentage = this.model.product.agencyRate * 100;
      }else if(this.model.product!=null && this.model.price){
        percentage = Math.round((1 - (this.model.price / this.model.product.sellingUnitPrice)) * 100);
      }
      return percentage;
    },
    minimumQty(){
      return this.editionMode ? this.edit.qty : null;
    },
    onHandQty(){
      return this.editionMode ? this.edit.quantity.onHand : null;
    },
    title(){
      return this.editionMode ? this.$i18n.t('products.editProductTitle') : this.$i18n.t('products.addProductTitle')
    },
    editionMode(){
      return this.edit!=null;
    },
    divHeight(){
      return "height :"+ (this.window.height-140) + "px"
    },
    width(){
      if(this.window.width > 1024){
        return "50%";
      }else{
        return "100%"
      }
    },
	},
  created(){
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
<style lang="scss" scoped>
.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:50px;
  margin-left:-40px;
  padding-left:40px;
  padding-top:10px;
  border-top:1px solid #E4E7ED
}

.drawer__content {
  margin-left:40px;
  margin-right:20px;
}

@media (max-width: 1366px) {
  .formContainer{
      margin-left:10%;
      width:80%;
    }
}

@media (max-width: 1024px) {
  .formContainer{
      margin-left:2%;
      width:98%;
    }
}

</style>
